var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('Header'),_c('main',{class:_vm.wrapperClass,style:(_vm.mainStyle),attrs:{"id":"main"}},[_vm._t("default")],2),_c('Footer'),_c('ClientOnly',[_c('CookieBarWrap')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }